// Decorative lettering follows section height without affecting document layout.
(() => {
  const sections = document.querySelectorAll('.cappture-daylight-page main .daylight, .cappture-daylight-page main .sc-section, .cappture-footer--pattern, .cappture-site-page main .sc-section, .cappture-site-page .cappture-intro, .cappture-site-page .cappture-page-hero');
  const observer = new ResizeObserver((entries) => {
    for (const { target } of entries) {
      target.style.setProperty('--cappture-watermark-height', `${Math.round(target.getBoundingClientRect().height)}px`);
    }
  });
  sections.forEach((section) => observer.observe(section));
})();
